/* eslint-disable react/prop-types */
/* eslint-disable react/react-in-jsx-scope */
import { getToRails } from "venuescanner-js/services/api";
import { $, pageLoaded } from "venuescanner-js/tools/elemental";
// eslint-disable-next-line no-unused-vars
import { node, jsxWatch } from "venuescanner-js/tools/jsx";
import {
  INTEGER,
  STRING,
} from "venuescanner-js/vanilla/models/ObservablePropTypes";
const urls = {
  add: "shortlist/add/",
  clear: "shortlist/clear",
  remove: "shortlist/remove/",
};
const getList = () => {
  const list =
    (window && window.widgetsData && window.widgetsData.shortlist_items) || [];
  return list.map((id) => id.toString());
};
const countInt = () => {
  return getList().length;
};
const count = new INTEGER(null, countInt());
let lastCount = countInt();
const displayCounter = new STRING(null, count.valueOf() > 0 ? "block" : "none");
const displayMessage = new STRING(null, "shortlist-widget-notify");
const notifierMessage = new STRING(null, "");

const Counter = ({ count }) => (
  <span
    class="shortlist-counter"
    style={{
      display: displayCounter,
    }}
  >
    {count}
  </span>
);

let hideMessageTimeout = null;
count.watch(() => {
  if (hideMessageTimeout) clearTimeout(hideMessageTimeout);
  const dif = count.valueOf() - lastCount;
  notifierMessage.set(
    dif > 0
      ? `${dif} space${dif === 1 ? "" : "s"} add to your shortlist`
      : `${-dif} space${dif === 1 ? "" : "s"} removed from your shortlist`
  );
  lastCount = count.valueOf();
  displayCounter.set(count.valueOf() > 0 ? "block" : "none");
  displayMessage.set("shortlist-widget-notify shortlist-widget-notify-active");
  hideMessageTimeout = setTimeout(() => {
    hideMessageTimeout = null;
    displayMessage.set("shortlist-widget-notify");
  }, 3000);
  const shortlistCountEvent = new CustomEvent("shortlistCountUpdate", {
    detail: {
      count: count.valueOf(),
    },
  });
  window.dispatchEvent(shortlistCountEvent);
});

const Notifier = ({}) => <div class={displayMessage}>{notifierMessage}</div>;

export const shortlist = {
  init: () => {
    if (!window.widgetsData) window.widgetsData = {};
    if (!window.widgetsData.shortlist_items)
      window.widgetsData.shortlist_items = [];
    const notifier = <Notifier />;
    const counter = <Counter count={count} />;

    // comment out notifier for now as we do not want this displayed as part of new requirements from Rich
    // $('nav.ux-navbar').append(notifier)

    $(".shortlist-widget.shortlist.shortlist--mobile").append(counter);
    $(".shortlist-widget.shortlist.shortlist--desktop").append(counter);
    window.shortlist = shortlist;
  },
  updateCount: () => {
    count.set(countInt());
  },
  increment: () => {
    count.set((count.valueOf() ? count.valueOf() * 1 : 0) + 1);
  },
  decrement: () => {
    count.set((count.valueOf() ? count.valueOf() * 1 : 0) - 1);
  },
  getList,
  getSpacesIds: function () {
    return this.getList();
  },
  // Check if space already added to the shortlist
  isAdded: function (space) {
    const spaceID = space.id || space;
    return this.getList().includes(spaceID.toString());
  },

  // Remove all spaces
  clear: async function (cb) {
    const data = await getToRails(`${urls.clear}`, { returnData: false });
    window.widgetsData.shortlist_items = data;
    this.updateCount();
    if (cb instanceof Function) cb();
  },

  // Add space to shortlist
  add: async function (space, cb) {
    let spaceID = space.id || space;
    spaceID = spaceID.toString();
    const data = await getToRails(`${urls.add}${spaceID}`, {
      returnData: false,
    });
    window.widgetsData.shortlist_items = data;
    this.updateCount();
    if (cb instanceof Function) cb();
  },

  // Remove space from shortlist
  remove: async function (space, cb) {
    let spaceID = space.id || space;
    spaceID = spaceID.toString();
    const data = await getToRails(`${urls.remove}${spaceID}`, {
      returnData: false,
    });
    window.widgetsData.shortlist_items = data;
    this.updateCount();
    if (cb instanceof Function) cb();
  },

  toggle: async function (space, button, cb) {
    let spaceID = space.id || space;
    spaceID = spaceID.toString();
    if (this.isAdded(spaceID)) {
      this.remove({ id: spaceID }, () => {
        if (button) $(button).removeClass("active");
        if (cb instanceof Function) cb();
      });
    } else {
      this.add({ id: spaceID }, () => {
        if (button) $(button).addClass("active");
        if (cb instanceof Function) cb();
      });
    }
  },
};
if (window) {
  pageLoaded(() => {
    shortlist.init();
  });
}
